/**
 * @file mutations for strategy modules
 */
import {initMarks} from '../util';

export default {
    setCodes(state, codes) {
        state.codes = codes;
    },
    setMarks(state, marks) {
        initMarks(marks);
        state.marks = marks;
    }
}